import { render, staticRenderFns } from "./ScanQrCodeElement.vue?vue&type=template&id=806371d6"
import script from "./ScanQrCodeElement.vue?vue&type=script&lang=ts"
export * from "./ScanQrCodeElement.vue?vue&type=script&lang=ts"
import style0 from "./ScanQrCodeElement.vue?vue&type=style&index=0&id=806371d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports